import { useEffect } from 'react';

const ApexForgeScriptLoader = () => {
    useEffect(() => {
        const script = document.createElement('script');

        script.id = 'apex-forge-esm-script';
        script.type = 'module';
        script.src = '/api/apex-forge/apex-forge-script';

        document.head.appendChild(script);

        return () => {
            script.remove();
        };
    }, []);

    return null;
};

export default ApexForgeScriptLoader;
